import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { useAppContext } from 'providers/AppProvider';
import { PieChart } from 'echarts/charts';
import { useMemo } from 'react';
echarts.use([PieChart]);
export type ChartType = 'application' | 'shortlisted' | 'rejected';

type Props = {
  value: number;
  type: ChartType;
};

const primaryColorMapping: Record<ChartType, string> = {
  application: '#A256BB',
  rejected: '#FDA32D',
  shortlisted: '#00CEDD'
};
const primaryLightColorMapping: Record<ChartType, string> = {
  application: '#E1CDE8',
  rejected: '#FDE3B5',
  shortlisted: '#D1F7F8'
};

const RecruiterStatsProgressChart = ({ value, type }: Props) => {
  const { getThemeColor } = useAppContext();

  const options = useMemo(() => {
    const name = `+${value}%`;
    const data = [value, 100 - value];
    return {
      color: [primaryColorMapping[type], primaryLightColorMapping[type]],
      legend: { show: false },
      series: [
        {
          name,
          type: 'pie',
          radius: ['100%', '87%'],
          avoidLabelOverlap: false,
          emphasis: {
            scale: false,
            itemStyle: {
              color: 'inherit'
            }
          },
          itemStyle: {
            borderWidth: 2,
            borderColor: getThemeColor('body-bg')
          },
          label: {
            show: true,
            position: 'center',
            formatter: '{a}',
            fontSize: 16,
            color: getThemeColor('light-text-emphasis')
          },
          data
        }
      ],
      grid: { containLabel: true }
    };
  }, [value, getThemeColor, type]);

  return (
    <ReactEChartsCore
      echarts={echarts}
      option={options}
      style={{ height: '80px', width: '100%' }}
    />
  );
};

export default RecruiterStatsProgressChart;
